import {
  BaseMarketingBlockModalComponent
} from "../components/modals/base-marketing-block-modal/base-marketing-block-modal.component";
import {MarketingBlocksModalConfig} from "../types/product-card-marketing-blocks.types";
import {
  MbWebsiteLinksModalComponent
} from "../components/modals/mb-website-links-modal/mb-website-links-modal.component";

const fields = [ 'usp', 'productValues', 'productDescriptions', 'productUsageRules', 'websiteLinks', 'websiteBackups', 'marketingDrafts' ];

export const marketingBlocksModalConfig: Record<string, MarketingBlocksModalConfig> = {};

fields.forEach(fieldName => {
  marketingBlocksModalConfig[fieldName] = {
    component: fieldName === 'websiteLinks'
      ? MbWebsiteLinksModalComponent
      : BaseMarketingBlockModalComponent,
    fieldName,
    width: '500px'
  };
});
